import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  box: {
    '& .MuiCheckbox-root': {
      padding: 5,
      height: 18,
      width: 18,
      borderRadius: 0,

      '& svg': {
        color: theme.primary.p3,
      },

      '&.Mui-checked': {
        background: theme.primary.p2,

        '& svg': {
          color: theme.primary.p3,
        },
      },

      '&.Mui-disabled': {
        opacity: 0.48,
      },
    },
  },
}));

export default useStyles;
